import { localStorageOrDefault, cacheInLocalStorage } from "../utils";
import { SET_USERINFO, LOGOUT, Action, State } from './types';

const initial = localStorageOrDefault('userInfo', {});

function userInfo(state = initial, action: Action): State {
    return {
        [SET_USERINFO]: action.payload,
        [LOGOUT]: null
    }[action.type] || state;
}


export default cacheInLocalStorage(userInfo)